import { render, staticRenderFns } from "./ShoppingGuide.vue?vue&type=template&id=1f282d4e&"
import script from "./ShoppingGuide.vue?vue&type=script&lang=js&"
export * from "./ShoppingGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports